import {
  NovuProvider,
  PopoverNotificationCenter,
  NotificationBell,
  IMessage,
} from '@novu/notification-center'
import { useGetIdentity } from 'react-admin'
import { useNavigate } from 'react-router-dom'
import config from '../../config'
export const NotificationCenter = ({ coproprietaireId }) => {
  const navigate = useNavigate()
  const { isLoading, identity } = useGetIdentity()

  if (!identity) return null

  function onNotificationClick(notification) {
    navigate(notification.cta.data.url)
  }

  return (
    <NovuProvider
      subscriberId={coproprietaireId}
      applicationIdentifier={config.NOVU_APP_ID}
      i18n="fr"
    >
      <PopoverNotificationCenter
        onNotificationClick={onNotificationClick}
        colorScheme={'light'}
      >
        {({ unseenCount }) => <NotificationBell unseenCount={unseenCount} />}
      </PopoverNotificationCenter>
    </NovuProvider>
  )
}

export default NotificationCenter
